import React from "react";

const InputField = ({
    label,
    value,
    onChange,
    placeholder,
    name,
    error,
    type = "text",
    icon: Icon,
    isLoading,
    suggestions = [],
    onSuggestionClick,
    className = "",
    ...props
}) => {
    return (
        <div className="space-y-2">
            {label && <label className="block text-sm font-medium text-gray-700">{label}</label>}
            <div className="relative">
                {Icon && (
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Icon className="h-5 w-5 text-gray-400" />
                    </div>
                )}
                <input
                    type={type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className={`block w-full ${Icon ? 'pl-10' : 'pl-3'} pr-3 py-2.5 text-gray-900 rounded-lg border border-gray-300 
                    focus:ring-2 focus:ring-darkGreen focus:border-transparent ${className}`}
                    {...props}
                />
                {isLoading && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        <div className="animate-spin h-5 w-5 border-2 border-darkGreen border-t-transparent rounded-full" />
                    </div>
                )}
                {suggestions.length > 0 && (
                    <ul className="absolute z-10 w-full bg-white mt-1 rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-auto">
                        {suggestions.map((suggestion, index) => (
                            <li
                                key={index}
                                onClick={() => onSuggestionClick?.(suggestion)}
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                            >
                                {suggestion.description}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>
    );
};

export default InputField; 